/*
* AJAX Holiday Property List module
*
* Script is looking for appropriate AJAX dependant elements inserted to the page via WordPress Shortcodes or Widgets.
*
* ELEMENTS:
* List - main element (property-list-list)
* List (Map) - satellite element (property-list-map)
* Information - satellite element (property-list-information)
* Pagination - satellite element (property-list-pagination)
*
*/
OC_Ajax_property_list = {
	p_initialised: false,
	p_list_id: '[data-oc-ajax-id="property-list-list"]', // The ID to find AJAX Property List List elements
	p_map_id: '[data-oc-ajax-id="property-list-map"]', // The ID to find AJAX Property List Map elements
	p_information_id: '[data-oc-ajax-id="property-list-information"]', // The ID to find AJAX Property List Information elements
	p_pagination_id: '[data-oc-ajax-id="property-list-pagination"]', // The ID to find AJAX Property List Pagination elements
	p_global_id: '[data-oc-ajax-class="property-list"]', // The global ID for all the AJAX Property List elements
	p_element_count: 0, // Track the number of Property List elements
	p_template: '',
	// Initialise AJAX Property List elements on startup.
	init : function(pm_options = {})
	{
		// Detect the count of Property List Elements.
		OC_Ajax_property_list.p_element_count = jQuery(OC_Ajax_property_list.p_list_id).size();
		
		// Initialise UI.
		OC_Ajax_property_list.init_ui();
		
		// Run the List first time.
		var config = {};
		OC_Ajax_property_list.load_list(config);
	}
	,
	load_list : function(pm_options = {})
	{	
		//if( is_empty(property_list_options) )
		//sh__site_object
		
		// Look for the central Property List element.
		if( OC_Ajax_property_list.p_element_count > 0 )
		{			
			//OC_Ajax_property_list.init_ui();
			
			// Get the Property Data.
			jQuery(OC_Ajax_property_list.p_list_id).each(function(){
				
				// Track the Property List element.
				var property_list_element = jQuery(this);
				
				// Config options for the element.
				var property_list_options = JSON.parse(property_list_element.attr('data-oc-options'));
				
				// Validate Property List Options.
				if( is_empty(property_list_options) )
				{
					// Ensure request is an object. JSON parse emitting empty array.
					property_list_options = {};
				}
				
				// The Template path for the element.
				var template = property_list_element.attr('data-oc-template');
				
				var config = {};
				
				// Look for custom search configuration.
				// We only want to over-ride in each case if values are defined. This allows initial page values.
				if( typeof pm_options.arrival !== 'undefined' ){ property_list_options.arrival = pm_options.arrival; }
				if( typeof pm_options.departure !== 'undefined' ){ property_list_options.departure = pm_options.departure; }
				if( typeof pm_options.suburb !== 'undefined' ){ property_list_options.suburb = pm_options.suburb; }
				if( typeof pm_options.sleeps_min !== 'undefined' ){ property_list_options.sleeps_min = pm_options.sleeps_min; }
				if( typeof pm_options.bedrooms_min !== 'undefined' ){ property_list_options.bedrooms_min = pm_options.bedrooms_min; }
				if( typeof pm_options.building_type !== 'undefined' ){ property_list_options.building_type = pm_options.building_type; }
				if( typeof pm_options.keyword_search !== 'undefined' ){ property_list_options.keyword_search = pm_options.keyword_search; }
				if( typeof pm_options.features_include !== 'undefined' ){ property_list_options.features_include = pm_options.features_include; }
				if( typeof pm_options.sort_combo !== 'undefined' ){ property_list_options.sort_combo = pm_options.sort_combo; }
				if( typeof pm_options.page_number !== 'undefined' ){ property_list_options.page_number = pm_options.page_number; }
				if( typeof pm_options.feature_details_include !== 'undefined' ){ property_list_options.feature_details_include = pm_options.feature_details_include; }
				if( typeof pm_options.price_max !== 'undefined' ){ property_list_options.price_max = pm_options.price_max; }
				if( typeof pm_options.price_min !== 'undefined' ){ property_list_options.price_min = pm_options.price_min; }
				if( typeof pm_options.room_type !== 'undefined' ){ property_list_options.room_type = pm_options.room_type; }
				if( typeof pm_options.properties_per_page !== 'undefined' ){ property_list_options.properties_per_page = pm_options.properties_per_page; }
				if( typeof pm_options.property_select !== 'undefined' ){ property_list_options.property_select = pm_options.property_select; }
				if( typeof pm_options.property_site_id !== 'undefined' ){ property_list_options.property_site_id = pm_options.property_site_id; }
				
				// Check for Session data over-rides.
				if( sessionStorage.getItem('oc_property_list_config') !== null )
				{
					if( typeof sessionStorage.getItem('oc_property_list_config') !== 'object' )
					{
						var property_list_config = sessionStorage.getItem('oc_property_list_config');
						var property_list_config_obj = JSON.parse(property_list_config);
						
						if( typeof property_list_config_obj.arrival !== 'undefined' ){ property_list_options.arrival = property_list_config_obj.arrival; }
						if( typeof property_list_config_obj.departure !== 'undefined' ){ property_list_options.departure = property_list_config_obj.departure; }
						if( typeof property_list_config_obj.suburb !== 'undefined' ){ property_list_options.suburb = property_list_config_obj.suburb; }
						if( typeof property_list_config_obj.sleeps_min !== 'undefined' ){ property_list_options.sleeps_min = property_list_config_obj.sleeps_min; }
						if( typeof property_list_config_obj.bedrooms_min !== 'undefined' ){ property_list_options.bedrooms_min = property_list_config_obj.bedrooms_min; }
						if( typeof property_list_config_obj.building_type !== 'undefined' ){ property_list_options.building_type = property_list_config_obj.building_type; }
						if( typeof property_list_config_obj.keyword_search !== 'undefined' ){ property_list_options.keyword_search = property_list_config_obj.keyword_search; }
						if( typeof property_list_config_obj.features_include !== 'undefined' ){ property_list_options.features_include = property_list_config_obj.features_include; }
						if( typeof property_list_config_obj.sort_combo !== 'undefined' ){ property_list_options.sort_combo = property_list_config_obj.sort_combo; }
						if( typeof property_list_config_obj.page_number !== 'undefined' ){ property_list_options.page_number = property_list_config_obj.page_number; }
						if( typeof property_list_config_obj.feature_details_include !== 'undefined' ){ property_list_options.feature_details_include = property_list_config_obj.feature_details_include; }
						if( typeof property_list_config_obj.price_max !== 'undefined' ){ property_list_options.price_max = property_list_config_obj.price_max; }
						if( typeof property_list_config_obj.price_min !== 'undefined' ){ property_list_options.price_min = property_list_config_obj.price_min; }
						if( typeof property_list_config_obj.room_type !== 'undefined' ){ property_list_options.room_type = property_list_config_obj.room_type; }
						if( typeof property_list_config_obj.properties_per_page !== 'undefined' ){ property_list_options.properties_per_page = property_list_config_obj.properties_per_page; }
						if( typeof property_list_config_obj.property_select !== 'undefined' ){ property_list_options.property_select = property_list_config_obj.property_select; }
						if( typeof property_list_config_obj.property_site_id !== 'undefined' ){ property_list_options.property_site_id = property_list_config_obj.property_site_id; }
						
						// Empty the data as we only want to use once.
						///var config_reset = {};
						///sessionStorage.setItem('oc_property_list_config', JSON.stringify(config_reset));//localStorage.setItem(key, true);
						
						// Emit event. After Custom Session List Over-write.
						var options = property_list_config_obj;
						//options.triggered = true;
						jQuery(document).trigger('oc_property_list_external_update',options);
					}
				}
				
				// Show global content loader.
				Content_loader.show();
				
				config.options = property_list_options;
				config.template = template;
				OC_Ajax_property_list.get_data(config);
				
				// Track initialisation.
				OC_Ajax_property_list.p_initialised = true;
			});
		}
	}
	,
	init_ui : function()
	{	
		// Respond to AJAX property list data received.
		jQuery(document).on('oc_property_list_ajax_html_result',function(event,pm_options){
			
			var result = pm_options.result;
			if( result.success )
			{
				jQuery(OC_Ajax_property_list.p_global_id).each(function(){
					
					var page_element = jQuery(this);
					var modules = page_element.attr('data-oc-modules');
					var views = page_element.attr('data-oc-views');
					var config = page_element.attr('data-oc-config');
					
					//OC_Ajax_property_list.set_ui(page_element, result);
					
					// Get HTML to load.
					var html_content = '';
					
					if( modules == 'list' )
					{
						if( views == 'map' )
						{
							html_content = jQuery(result.html.map);
						}
						else // Main List.
						{
							html_content = jQuery(result.html.list);
							
							var arrival = jQuery('#property-list-search').find('[name="arrival"]').val();
							arrival = arrival.replace(/\s/g,'+');
							var departure = jQuery('#property-list-search').find('[name="departure"]').val();
							departure = departure.replace(/\s/g,'+');
							
							// Check if we need to add Arrival and Departure parameters to the links (normally done in the Request).
							if( arrival != ''  || departure != '' )
							{
								html_content.find('a.property-link').each(function(event){
									var link = jQuery(this).attr('href');
									var updated_link = link + '&arrival=' + arrival + '&departure=' + departure;
									jQuery(this).attr('href',updated_link);
								});
							}
							
							// Update the config options so we can track the state of the search.
							var updated_config = result.options;
							var updated_config_string = JSON.stringify(updated_config);
							
							//page_element.attr('data-oc-test',updated_config_string);
							page_element.attr('data-oc-options',updated_config_string);
						}
					}
					else if( modules == 'information' )
					{
						html_content = jQuery(result.html.information);
					}
					else if( modules == 'pagination' )
					{
						// Set the HTML content.
						html_content = jQuery(result.html.pagination);
						
						// Make adjustments to the HTML content.
						html_content.find('li a').each(function(event){
							
							var link = jQuery(this).attr('href');
							var link_uri = new URI(link);
							var link_query = link_uri.search(true);
							var page_number = link_query.page_number;
							
							/*
							// Get current URL URI instance.
							var uri = new URI();
							
							// Get query string.
							var query = uri.search(); // String
							
							// Check if we have a query in the URL.
							if( query.length > 0 )
							{
								// Set our page number.
								uri.setSearch('page_number', page_number);
								
								// Get query data.
								var query_data = uri.search(true); // Object
								
								link_uri.search(query_data);
								
								// Set pagination link.	
								jQuery(this).attr('href',link_uri.toString());
							}
							*/
							
							// Handle AJAX pagination Nav.
							jQuery(this).click(function(event){
								
								// Emit event. After Pagination Navigation.
								var options = {};
								options.page_number = page_number;
								jQuery(document).trigger('oc_property_list_pagination_nav',options);
								
								event.preventDefault();
								//event.stopPropagation();
							});
						});
					}
					
					// Load HTML.
					page_element.html(html_content);
					
					// Init maps.
					Maps.init();
					
					// Hide global content loader.
					Content_loader.hide();
					
					// Emit event.
					var options = {};
					jQuery(document).trigger('oc_property_list_ajax_html_render',options);
					
				});
			}
		});
		
		// Respond to Search Form Submission.
		jQuery(document).on('oc_property_search_submit_after',function(event,pm_options){
			
			// Check whether we are coming from an AJAX form.
			// We don't want to be redirecting from a standard page.
			var is_ajax = pm_options.form.hasClass('use-ajax');
			if( !is_ajax )
			{
				return(false);
			}
			
			// Detect if we are on the home page.
			var is_home = jQuery('body').hasClass('home');
			
			// Detect if we are on the Properties page.
			var is_properties = jQuery('body').hasClass('properties');
			
			// Ensure a config item is present.
			var property_list_config = {};
			sessionStorage.setItem('oc_property_list_config', JSON.stringify(property_list_config));
			
			// Get search parameters.
			var arrival = pm_options.form.find('[name="arrival"]').val();
			var departure = pm_options.form.find('[name="departure"]').val();
			var suburb = pm_options.form.find('[name="suburb"]').val();
			var region_suburb = pm_options.form.find('[name="region_suburb"]').val();
			var region_search = pm_options.form.find('[name="region_search"]').val();
			var sleeps_min = pm_options.form.find('[name="sleeps_min"]').val();
			var bedrooms_min = pm_options.form.find('[name="bedrooms_min"]').val();
			var building_type = pm_options.form.find('[name="building_type"]').val();
			var keyword_search = pm_options.form.find('[name="keyword_search"]').val();
			var features_include = pm_options.form.find('[name="features_include"]').val();
			var feature_details_include = pm_options.form.find('[name="feature_details_include"]').val();
			var price_max = pm_options.form.find('[name="price_max"]').val();
			var price_min = pm_options.form.find('[name="price_min"]').val();
			var room_type = pm_options.form.find('[name="room_type"]').val();
			var property_select = pm_options.form.find('[name="property_select"]').val();
			var property_site_id = pm_options.form.find('[name="property_site_id"]').val();
			
			// Assemble search configuration.
			var config = {};
			config.arrival = arrival;
			config.departure = departure;
			config.suburb = suburb;
			config.region_suburb = region_suburb;
			config.region_search = region_search;
			config.sleeps_min = sleeps_min;
			config.bedrooms_min = bedrooms_min;
			config.building_type = building_type;
			config.keyword_search = keyword_search;
			config.features_include = features_include;
			config.feature_details_include = feature_details_include;
			config.price_max = price_max;
			config.price_min = price_min;
			config.room_type = room_type;
			config.property_select = property_select;
			config.property_site_id = property_site_id;
			
			// Check which page we are on.
			if( is_properties ) // We're already on the Properties page.
			{
				// Empty UI.
				OC_Ajax_property_list.unset_ui();
				
				// Load the AJAX Property List.
				OC_Ajax_property_list.load_list(config);
			}
			else // We're coming from another page to the Properties page. Eg: Home.
			{
				var config_string = JSON.stringify(config);
								
				// Store the config in a session cookie.		
				sessionStorage.setItem('oc_property_list_config', config_string);
								
				// Navigate to the Properties page.		
				window.location.href = pm_options.form.attr('action');
			}
		});
		
		// Respond to Search Form Submission.
		jQuery(document).on('oc_property_sort_submit_before',function(event,pm_options){
			
			// Get search parameters.
			var sort_combo = pm_options.form.find('[name="sort_combo"]').val();
			
			// Empty UI.
			OC_Ajax_property_list.unset_ui();
			
			// Assemble sort configuration.
			var config = {};
			config.sort_combo = sort_combo;
			OC_Ajax_property_list.load_list(config);
		});
		
		// Respond to Pagination Navigation.
		jQuery(document).on('oc_property_list_pagination_nav',function(event,pm_options){
			
			// Empty UI.
			OC_Ajax_property_list.unset_ui();
			
			// TODO: We might need to reset page number for certain searches.
			// Get current URL URI instance.
			var uri = new URI();
			uri.setSearch({page_number: pm_options.page_number});
			
			// Set the base URL
			///const baseURL = 'https://www.example.com/search';
			// Create a new URLSearchParams object
			///const params = new URLSearchParams();
			// Add the query parameter and its value
			///params.append('q', 'javascript');
			// Add the URLSearchParams object to the base URL
			///const url = `${baseURL}?${params.toString()}`;
			// The final URL is: https://www.example.com/search?q=javascript
			
			// Assemble search configuration.
			var config = {};
			config.page_number = pm_options.page_number;
			OC_Ajax_property_list.load_list(config);
		});
	}
	,
	set_ui : function()
	{
	}
	,
	unset_ui : function()
	{
		jQuery(OC_Ajax_property_list.p_global_id).each(function(){
			
			var page_element = jQuery(this);
			var modules = page_element.attr('data-oc-modules');
			var views = page_element.attr('data-oc-views');
			var config = page_element.attr('data-oc-config');
			
			if( modules == 'list' )
			{
				if( views == 'map' )
				{
					html_content = '<div class="oc-loading">Loading</div>';
				}
				else
				{
					html_content = '<div class="oc-loading">Loading</div>';
				}
			}
			else if( modules == 'information' )
			{
				html_content = '<div class="oc-loading">Loading</div>';
			}
			else if( modules == 'pagination' )
			{
				'<div class="oc-loading">Loading</div>';
			}
			
			// Load HTML.
			page_element.html(html_content);
			
		});
		
		// Show global content loader.
		//Content_loader.show();
		
		// Emit event. After Property List UI unset.
		var options = {};
		jQuery(document).trigger('oc_property_list_ui_unset',options);
	}
	,
	// Get the data for the Property List
	get_data : function( pm_options = {} )
	{
		// Get config parameters.
		var template = (typeof pm_options.template !== 'undefined') ? pm_options.template : '';
		var view = (typeof pm_options.view !== 'undefined') ? pm_options.view : {};
		var options = (typeof pm_options.options !== 'undefined') ? pm_options.options : {};
		
		// Get the path to the Property List AJAX service. Stored in OnCloud.
		///var data_url = oc__oncloud_settings.url + 'library/property/services/property-list-ajax.php';
		
		// Data URL - AJAX Admin URL stored in page config object.
		var data_url = oc__system_settings.ajax_url;
		
		// Store configuration to send to the service.
		var data_options = {};
		data_options.action = 'oc_property_list';
		data_options.use_queue = false;
		data_options.include_html = true;
		data_options.template = template;
		data_options.view = view;
		data_options.options = options;
		
		/*
		jQuery.ajax({
			url: data_url,
			type: 'POST',
			data: JSON.stringify(data_options),
			contentType: 'text/plain; charset=utf-8',
			dataType: 'json',
			success: function(result){
				// Emit event for elements to respond to.
				var options = {};
				options.result = result;
				//options.html = html_content;
				jQuery(document).trigger('oc_property_list_ajax_html_result',options);
			}
		});
		*/
		
		// Admin AJAX call.
		jQuery.ajax({
			type: 'post',
			dataType: 'json',
			url: data_url,
			data: data_options,
			success: function(result){
				// Emit event for elements to respond to.
				var options = {};
				options.result = result.data;
				//options.html = html_content;
				jQuery(document).trigger('oc_property_list_ajax_html_result',options);
			}
		});
	}
}

function is_empty(obj) {
	// null and undefined are "empty"
	if (obj == null) return true;
	
	// Assume if it has a length property with a non-zero value
	// that that property is correct.
	if (obj.length > 0)    return false;
	if (obj.length === 0)  return true;
	
	// If it isn't an object at this point
	// it is empty, but it can't be anything *but* empty
	// Is it empty?  Depends on your application.
	if (typeof obj !== "object") return true;
	
	// Otherwise, does it have any properties of its own?
	// Note that this doesn't handle
	// toString and valueOf enumeration bugs in IE < 9
	for (var key in obj) {
		if (hasOwnProperty.call(obj, key)) return false;
	}
	
	return true;
}

jQuery(document).ready(function(jQuery){
	var config = {};
	OC_Ajax_property_list.init(config);
});